import Vue from 'vue';
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate/dist/vee-validate.full'
import pt_BR from 'vee-validate/dist/locale/pt_BR.json'

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

localize('pt_BR', pt_BR)